import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSupport(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M8 15h8v-.55c0-.733-.367-1.325-1.1-1.775-.733-.45-1.7-.675-2.9-.675s-2.167.225-2.9.675c-.733.45-1.1 1.042-1.1 1.775V15Zm4-4c.55 0 1.02-.196 1.412-.588C13.804 10.021 14 9.55 14 9c0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 7c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 9c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm-6 8-2.3 2.3c-.317.317-.68.387-1.088.212-.408-.175-.612-.487-.612-.937V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 3h16c.55 0 1.02.196 1.413.587C21.803 3.98 22 4.45 22 5v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 19H6Zm-.85-2H20V5H4v13.125L5.15 17Z"
      />
    </BaseIcon>
  );
}
